import { render, staticRenderFns } from "./remindArrival.vue?vue&type=template&id=de8e06d8&scoped=true"
import script from "./remindArrival.vue?vue&type=script&lang=js"
export * from "./remindArrival.vue?vue&type=script&lang=js"
import style0 from "./remindArrival.vue?vue&type=style&index=0&id=de8e06d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8e06d8",
  null
  
)

export default component.exports